export default "__VITE_ASSET__zRoV$efE__"